import React from 'react';
import Type from 'prop-types';
import { get, noop } from 'lodash';
import { MultiStepForm } from 'components';
import { getServerErrorMessage } from 'utils/errors';
import { GetCode, GetToken } from '../steps';

const SignInForm = props => {
  const steps = [GetCode, GetToken];
  const { initialValues, onFinalSubmit } = props;

  const generateError = errorObject => {
    const serverResponse = get(errorObject, 'response.data', {});
    const responseDataValues = Object.values(serverResponse);
    const isHandledServerError = responseDataValues.length > 0;

    if (isHandledServerError) {
      const hasMultiError = responseDataValues.some(
        value => Array.isArray(value) && value.length > 0,
      );

      if (hasMultiError) {
        const errorMessage = responseDataValues
          .map(messages => {
            return messages[0];
          })
          .join('\n');

        return errorMessage;
      }
    }
    return getServerErrorMessage(errorObject);
  };

  return (
    <MultiStepForm
      initialValues={initialValues}
      getErrorMessage={generateError}
      onFinalSubmit={onFinalSubmit}
      steps={steps}
    />
  );
};

SignInForm.propTypes = {
  initialValues: Type.objectOf(Type.oneOfType([Type.array, Type.string, Type.number, Type.bool])),
  onFinalSubmit: Type.func,
};

SignInForm.defaultProps = {
  initialValues: {
    ...GetCode.initialValues,
    ...GetToken.initialValues,
  },
  onFinalSubmit: noop,
};

export default SignInForm;
